module.exports = __webpack_public_path__ + "media/images/desenvolvimento1-6c038cbbb89a4fbe1898d6d2d4ec22ad.jpg";